/**
 * AffiliateControl has no dedicated route; POSTBACK_LINKS_REFERENCE.md directs
 * operators to `/postbacks/custom`. This contract exists specifically to encode
 * the documented pitfall: AffiliateControl does not document a currency macro
 * at all, so a CPA link must hardcode a confirmed payout currency instead of
 * defaulting to EUR the way every other platform's CPA template does. There is
 * no backoffice/TMA/Telegram PLATFORMS entry for AffiliateControl — it is not
 * part of the "cover every backoffice PLATFORMS id" equivalence requirement,
 * only of the five documented pitfalls this package must encode as tests.
 */
export const affiliateControlContract = {
    id: 'affiliatecontrol',
    displayName: 'AffiliateControl (via /postbacks/custom)',
    route: 'custom',
    trackingTagMacro: '{extid}',
    amountBehavior: 'FTD amount from {depositAmount}; CPA amount from {revenue}. AffiliateControl documents NO currency ' +
        'macro at all — unlike every other platform, its CPA link cannot default to a fixed EUR either, because ' +
        'the payout currency varies per partner account and must be confirmed before the link is issued.',
    duplicateParamPolicy: 'array-then-tolerant-last-wins',
    caseSensitiveParams: [],
    requiresFixedCurrencyForCpa: true,
    pitfalls: [
        'AffiliateControl does not document a currency macro. For CPA revenue analytics, confirm the ' +
            "partner account's payout currency and set a fixed currency=<ISO4217> value before issuing the link " +
            '— do not guess EUR.',
        '{requestId} is not mapped until transaction-level mapping exists; {eventType} must not be passed ' +
            'through directly — the event is hardcoded per postback URL instead.',
    ],
    sourceRefs: [
        'POSTBACK_LINKS_REFERENCE.md:337-397 (AffiliateControl section, SpinBetter example)',
    ],
    events: [
        {
            event: 'REG',
            eventValue: 'registration',
            params: [
                { ourParam: 'uid', macro: '{playerId}' },
                { ourParam: 'subid', macro: '{subid1}' },
                { ourParam: 'tracking_tag', macro: '{extid}' },
            ],
        },
        {
            event: 'FTD',
            eventValue: 'ftd',
            params: [
                { ourParam: 'uid', macro: '{playerId}' },
                { ourParam: 'subid', macro: '{subid1}' },
                { ourParam: 'amount', macro: '{depositAmount}' },
                { ourParam: 'tracking_tag', macro: '{extid}' },
            ],
        },
        {
            event: 'QUALIFIED_CPA',
            eventValue: 'cpa',
            params: [
                { ourParam: 'uid', macro: '{playerId}' },
                { ourParam: 'subid', macro: '{subid1}' },
                { ourParam: 'amount', macro: '{revenue}' },
                { ourParam: 'currency', macro: '<ACCOUNT_CURRENCY>' },
                { ourParam: 'tracking_tag', macro: '{extid}' },
            ],
            notes: [
                'Do not paste this URL until <ACCOUNT_CURRENCY> is replaced with the confirmed payout currency.',
            ],
        },
    ],
};
//# sourceMappingURL=affiliatecontrol.js.map